import classes from "./ProgressFlow.module.css";
import CircleWithDotBlue from "../../../images/orderInformation/circleWithDotIconBlue.svg";
import CircleWithDotGray from "../../../images/orderInformation/circleWithDotIconGray.svg";
import AddressIconBlue from "../../../images/orderInformation/addressIconBlue.svg";
import AddressIconGray from "../../../images/orderInformation/addressIconGray.svg";
import AddressIconRed from "../../../images/orderInformation/addressIconRed.svg";
import { useSelector } from "react-redux";
import { formatDateTimeString } from "../../../helperFunctions/formatDateTimeString";

const CANON = {
  NEW: "NEW",
  ACCEPTED: "ACCEPTED",
  PICKED: "PICKED",
  DELIVERED: "DELIVERED",
  CANCELLED: "CANCELLED",
};

const labels = {
  en: {
    [CANON.NEW]: "New",
    [CANON.ACCEPTED]: "Accepted",
    [CANON.PICKED]: "Picked",
    [CANON.DELIVERED]: "Delivered",
    [CANON.CANCELLED]: "Cancelled",
  },
  no: {
    [CANON.NEW]: "Ny",
    [CANON.ACCEPTED]: "Akseptert",
    [CANON.PICKED]: "Plukket opp",
    [CANON.DELIVERED]: "Levert",
    [CANON.CANCELLED]: "Kansellert",
  },
};

function normalizeStatus(s) {
  const key = String(s || "").toLowerCase();
  if (key === "new") return CANON.NEW;
  if (key === "accepted") return CANON.ACCEPTED;
  if (key === "picked") return CANON.PICKED;
  if (key === "delivered") return CANON.DELIVERED;
  if (key === "cancelled") return CANON.CANCELLED;
  return null;
}

const ProgressFlow = ({ progress, errorMsg }) => {
  const { language } = useSelector((state) => state.global);
  const t = labels[language] || labels.en;

  if (!Array.isArray(progress) || progress.length === 0) {
    return <div className={classes.errorMsg}>{errorMsg}</div>;
  }

  const lastRaw = progress[progress.length - 1]?.status_name;
  const last = normalizeStatus(lastRaw);

  // Build flow & completed sets using CANON values only
  let flow = [CANON.NEW, CANON.ACCEPTED, CANON.PICKED];
  let completed = new Set();

  switch (last) {
    case CANON.NEW:
      flow = [CANON.NEW, CANON.ACCEPTED, CANON.PICKED];
      completed = new Set([CANON.NEW]);
      break;
    case CANON.ACCEPTED:
      flow = [CANON.ACCEPTED, CANON.PICKED, CANON.DELIVERED];
      completed = new Set([CANON.ACCEPTED]);
      break;
    case CANON.PICKED:
      flow = [CANON.ACCEPTED, CANON.PICKED, CANON.DELIVERED];
      completed = new Set([CANON.ACCEPTED, CANON.PICKED]);
      break;
    case CANON.DELIVERED:
      flow = [CANON.ACCEPTED, CANON.PICKED, CANON.DELIVERED];
      completed = new Set([CANON.ACCEPTED, CANON.PICKED, CANON.DELIVERED]);
      break;
    case CANON.CANCELLED:
      flow = [CANON.NEW, CANON.ACCEPTED, CANON.CANCELLED];
      completed = new Set([CANON.NEW]);
      break;
    default:
      flow = [CANON.NEW, CANON.ACCEPTED, CANON.PICKED];
      completed = new Set();
  }

  const getIcon = (canonStatus) => {
    if (canonStatus === CANON.DELIVERED) {
      return completed.has(CANON.DELIVERED) ? AddressIconBlue : AddressIconGray;
    }
    if (canonStatus === CANON.CANCELLED) return AddressIconRed;
    return completed.has(canonStatus) ? CircleWithDotBlue : CircleWithDotGray;
  };

  const findItem = (canonStatus) =>
    progress.find((p) => normalizeStatus(p.status_name) === canonStatus);

  return (
    <div className={`${classes.shippingDetails} fadeInTranslate`}>
      {flow.map((canonStatus, idx) => {
        const item = findItem(canonStatus);
        const isCompleted = completed.has(canonStatus);

        return (
          <div key={canonStatus} className={classes.progressItem}>
            <div className={classes.progressItemImg}>
              <img src={getIcon(canonStatus)} alt="" />
              {idx < flow.length - 1 && (
                <div
                  className={`${classes.line} ${
                    isCompleted ? classes.blue : classes.gray
                  }`}
                />
              )}
            </div>
            <div className={classes.packageStatus}>
              <span>{t[canonStatus] || canonStatus}</span>
              {item && <p>{formatDateTimeString(item.timestamp)}</p>}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProgressFlow;
